/* Imports */
import React from "react"
import { Grid } from "fajny-react"
import { v4 as uuid } from "uuid"

import ComponentPage from "../../components/ComponentPage"
import ColorCard from "../../components/ColorCard"

import allColors from "../../data/all-colors"

const ColorsPage = () => {
    return (
        <ComponentPage>
            <Grid gap="s">
                {allColors.map(color => (
                    <ColorCard color={color} key={uuid()} />
                ))}
            </Grid>
        </ComponentPage>
    )
}

export default ColorsPage
